import React, { useState } from 'react'
import { BodyText, Button, Divider, TextArea } from '@paypalcorp/pp-react'
import { record } from '@paypalcorp/fpti'
import styles from './AiSearch.module.css'

type reasonOptions = {
  [key: string]: string
}
const REASON_MAP: reasonOptions = {
  toomuchinfo: 'Too much information',
  notenoughinfo: 'Not enough information to answer my question',
  lookingfor: "This isn't what I was looking for",
  incorrect: "I tried this and it didn't solve the problem",
  dontlike: "I don't like this feature or policy",
  other: 'Other',
}

const REASONS = Object.keys(REASON_MAP)

const FeedbackReason = ({
  answerId,
  searchID,
  setIsFeedbackOpen,
  setFeedbackSent,
}: {
  answerId: string
  searchID: string
  setIsFeedbackOpen: React.Dispatch<React.SetStateAction<boolean>>
  setFeedbackSent: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const fptiData = typeof window !== `undefined` && window.fpti
  const [selectedReason, setSelectedReason] = useState('')
  const [reasonDescription, setReasonDescription] = useState('')

  const fbReasonHandler = (reason: string) => {
    setSelectedReason(reason)

    if (fptiData) {
      record({
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          tag: `was this helpful-reason-${reason}`,
          link: `gen-ai-summary|feedback|was this helpful-reason-${reason}|${answerId}`,
          component: 'devdiscoverynodeweb',
          searchID,
        },
      })
    }
  }

  const fbFeedbackHandler = () => {
    if (fptiData) {
      record({
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          tag: `was this helpful-text`,
          link: `gen-ai-summary|feedback|was this helpful-text|${answerId}`,
          component: 'devdiscoverynodeweb',
          text: reasonDescription,
          searchID,
        },
      })
    }

    setIsFeedbackOpen(false)
    setFeedbackSent(true)
  }

  return (
    <>
      <BodyText
        className={`${styles.hc_fb_reason__title} ${styles.text_sm}`}
        strong
      >
        Why wasn't this information helpful?
      </BodyText>
      <ul className={`${styles.hc_fb_reason_options__section}`}>
        {REASONS.map((reason) => (
          <li
            key={`reason.${reason}`}
            className={`${styles.hc_fb_reason_option__title}${
              reason === selectedReason ? ' selected' : ''
            } ${styles.pl_3}`}
          >
            <BodyText
              className={`${styles.text_sm}`}
              onClick={() => fbReasonHandler(reason)}
            >
              {REASON_MAP[reason]}
            </BodyText>
            {reason === selectedReason && (
              <>
                <TextArea
                  name="feedback_text"
                  className={`${styles.text_sm} ${styles.hc_fb_reason_option__desc}`}
                  maxCharacters={100}
                  showCharacterCounter={true}
                  placeholder="Tell us more - please don't include personal info like your email or account numbers."
                  value={reasonDescription}
                  onChange={(e) => setReasonDescription(e.target.value)}
                  data-testid="hc-fb-reason-option-desc"
                />
                <Button
                  className={`${styles.text_sm}`}
                  size="sm"
                  data-testid="hc-fb-reason-option-btn-submit"
                  onClick={() => fbFeedbackHandler()}
                >
                  Send
                </Button>
              </>
            )}
          </li>
        ))}
      </ul>
    </>
  )
}

export default FeedbackReason
